import { useEffect, useRef, useState , useMemo} from "react";
import useGetTabs from "../hooks/useGetTabs";
import { useDispatch, useSelector } from "react-redux";
import {
  currentSelectedLanguage,
  storeSettingsData,
} from "../../../../StateManagement/actions";
import ControlMenu from "../SettingControls/Controls";
import axios from "axios";
import APIRequest from "../../../../Services/commonAPIConsumer";
import { Preview } from "@mui/icons-material";
import PreviewPopup from "../../../Controls/ModalPopUp/PreviewPopup";
import LoadingSpinner from "../../../Controls/Spinner/LoadingSpinner";
import {
  defaultCipherSettings, defaultFloatingSettings, defaultL1Settings, defaultL2Settings, defaultL3Settings
} from "./SettingsType";

export default function TabLayout({ tabMenuText, controlData }) {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState();
  const { getContentSecurityTabs, getSecurityLevelTabs } = useGetTabs();
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const defaultSetting = useSelector((state) => state.settings.defaultSetting);
  const settingFor = useSelector((state) => state.settings.settingFor);
  const settings = useSelector((state) => state.settings);
  const tabMap = {
    Personal: "personalTab",
    Company: "companyTab",
    Admin: "AdminTab",
  };
  const[isTab, setIsTab]=useState("");
  const [openLoader, setOpen] = useState(false);
  const [openLoaderSearch, setOpenLoaderSearch] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [FloatingTextSettings, setFloatingTextSettings] = useState(null);
  const [ispreviewClick, setIsPreviewClick] = useState(false);
  let cipherTextSettings = [];
  let cipherTextSettingsChanged = [];
  const [tabs, setTabs] = useState([]);
  const level = useRef("");
  let disableOnLock = false;
  const tabKey =
    tabMap[settings.settingFor === "User" ? "Personal" : settings.settingFor];
const selectedType =
  settings[tabKey]?.selectedTab === "ContentSecurity"
    ? settings[tabKey]?.settingsData?.[0]?.commonContentSecuritySetting
        ?.find(s => s.type === "IDLeakersType")?.keyValue
    : null;
  useEffect(() => {
    const { innerTabs } =
      tabMenuText !== "ContentSecurity"
        ? getSecurityLevelTabs()
        : getContentSecurityTabs();
    setTabs(innerTabs);
    setActiveTab(innerTabs[0]?.id);
  }, [tabMenuText]);

  const onTabSelectionHandler = (tabId) => {
    setActiveTab(tabId);
  };
  const handleCloseFnLnModal = () => {
    setIsPreviewClick(false);
  };
  const restoreDirectSendDefaults = () => {
    const defaultsMap = {
      l1: defaultL1Settings,
      l2: defaultL2Settings,
      l3: defaultL3Settings,
    };

    const currentLevel = level.current;
    const defaults = defaultsMap[currentLevel];
    if (!defaults) return;

    const existing =
      settings[tabKey]?.settingsData?.find(s=>s.settingFor === defaultSetting)?.[currentLevel] || [];

    let isAnyUnlockedChanged = false;

    const merged = existing.map(item => {
      const def = defaults.find(d => d.type === item.type);
      if (!def) return item;

      // Locked
      if (item.isLock === "true") {
        // User → respect lock
        if (settingFor === "User") {
          return {
            ...item,
            isLock: item.isLock,
            isOverride: item.isOverride,
            isDataChanged: false,
          };
        }

        // Company/Admin → restore value but keep lock
        if (
          item.keyValue !== def.keyValue &&
          def.keyValue !== item.prevValue
        ) {
          isAnyUnlockedChanged = true;
        }

        return {
          ...item,
          keyValue: def.keyValue,
          isLock: item.isLock,
          isOverride: item.isOverride,
          isDataChanged: false,
        };
      }
      //  Unlocked → restore default value
      if (
        item.keyValue !== def.keyValue &&
        def.keyValue !== item.prevValue
      ) {
        isAnyUnlockedChanged = true;
      }

      return {
        ...item,
        keyValue: def.keyValue,
        isLock: item.isLock,
        isOverride: item.isOverride,
        isDataChanged: false,
      };
    });

    const settingsData = {
      ...settings[tabKey].settingsData.find(s => s.settingFor === defaultSetting),
      [currentLevel]: merged,
    };

    //console.log("Restored Settings Data:", settingsData);

    dispatch(
      storeSettingsData({
        outerTabSelected: settingFor === "User" ? "Personal" : settingFor,
        innerTabSelected: "DirectSendDefaults",
        restoreDefaultSettings: {
          [currentLevel]: isAnyUnlockedChanged,
        },
        Settings: [
          {...settingsData},
          ...settings[tabKey].settingsData.filter(s => s.settingFor !== defaultSetting)
        ],
      })
    );
  };
useEffect(() => {
  // Only run for Content Security tab
  if (settings[tabKey]?.selectedTab !== "ContentSecurity") return;

  const commonSettings =
    settings[tabKey]?.settingsData?.[0]?.commonContentSecuritySetting;

  if (!selectedType) return;
  if (
    selectedType === "Floating Text Only" &&
    activeTab === "Cipher Text"
  ) {
    onTabSelectionHandler("Floating Text");
    return;
  }
  if (
    selectedType === "Cipher Text Only" &&
    activeTab === "Floating Text"
  ) {
    onTabSelectionHandler("Cipher Text");
  }
}, [settings, tabKey, activeTab]);


const handlePreview = async () => {
  try {
    const tabKey =
      tabMap[
        settings.settingFor === "User" ? "Personal" : settings.settingFor
      ];

    setOpen(true);
    setOpenLoaderSearch(true);

    const floatingTextSettings =
      settings[tabKey]?.settingsData?.[0]?.floatingText || [];

    const floatingTextSettingsChanged = floatingTextSettings.map(setting => ({
      type: setting.type,
      keyvalue: setting.keyValue,
    }));

    setFloatingTextSettings(floatingTextSettingsChanged);

    if (selectedType === "Floating Text Only") {
      setImagePreview([]);      
      setIsPreviewClick(true); 
      setOpen(false);
      setOpenLoaderSearch(false);
      return;
    }

    const cipherTextSettings =
      settings[tabKey]?.settingsData?.[0]?.cipherText || [];

    const cipherTextSettingsChanged = cipherTextSettings.map(setting => ({
      type: setting.type,
      keyvalue: setting.keyValue,
      keyCollection: setting.keyCollection,
      isOverride: setting.isOverride,
      isLock: setting.isLock,
    }));

    const formData = new FormData();
    formData.append(
      "identifyLeakers",
      JSON.stringify(cipherTextSettingsChanged)
    );
    const response = await APIRequest.POST(
      formData,
      `${process.env.REACT_APP_API + "/docs/IdLeakersPreview"}`
    );
    if (!response?.previewImages?.length) {
      setIsPreviewClick(false);
      setOpen(false);
      setOpenLoaderSearch(false);
      return;
    }

    setImagePreview(response.previewImages);
    setIsPreviewClick(true);
    setOpen(false);
    setOpenLoaderSearch(false);

  } catch (error) {
    console.error("Error while previewing:", error);
    setOpen(false);
    setOpenLoaderSearch(false);
    setIsPreviewClick(false);
  }
};

  

  const restoreContentSecurityDefaults = () => {
    const settingsData = {
      outerTabSelected: settingFor === "User" ? "Personal" : settingFor,
      innerTabSelected: tabMenuText,
      Settings: [],
      restoreDefaultSettings: {},
    };

    if (tabKey === "companyTab") {
      if (level.current === "cipherText") {
        let isDataSame=false;
        settings[tabKey].settingsData[0].cipherText.map((item) => {
          const index = defaultCipherSettings.findIndex(
            (setting) => setting.type === item.type
          );
          const defaultItem = defaultCipherSettings.find(
            (setting) => setting.type === item.type
          );
          if(item.keyValue!==defaultItem.keyValue  && defaultItem.keyValue !== item.prevValue){
             isDataSame=true;
          }
          defaultCipherSettings[index] = {
            ...defaultItem,
            isLock: item.isLock,
            isOverride: item.isOverride,
          };
        });
        settingsData.restoreDefaultSettings.cipher = isDataSame;
      } else if (level.current === "floatingText") {
        let isDataSame=false;
        settings[tabKey].settingsData[0].floatingText.map((item) => {
          const index = defaultFloatingSettings.findIndex(
            (setting) => setting.type === item.type
          );
          const defaultItem = defaultFloatingSettings.find(
            (setting) => setting.type === item.type
          );
          if(item.keyValue!==defaultItem.keyValue  && defaultItem.keyValue !== item.prevValue){
             isDataSame=true;
          }
          defaultFloatingSettings[index] = {
            ...defaultItem,
            isLock: item.isLock,
            isOverride: item.isOverride,
          };
        });
        settingsData.restoreDefaultSettings.floating = isDataSame;
      }
    } else if (tabKey === "personalTab") {
      if (level.current === "cipherText") {
        let isDataSame=false;
        settings[tabKey].settingsData[0].cipherText.map((item) => {
          const index = defaultCipherSettings.findIndex(
            (setting) => setting.type === item.type
          );
          const defaultItem = defaultCipherSettings.find(
            (setting) => setting.type === item.type
          );
          if(item.keyValue!==defaultItem.keyValue  && defaultItem.keyValue !== item.prevValue){
             isDataSame=true;
          }
          if (item.isLock === "true") {
            defaultCipherSettings[index] = {
              ...item,
              isLock: item.isLock,
            };
          } else {
            defaultCipherSettings[index] = {
              ...defaultItem,
              isLock: item.isLock,
            };
          }
        });
        isDataSame= isLock==='true' ? false : isDataSame;
        settingsData.restoreDefaultSettings.cipher = isDataSame;
      } else if (level.current === "floatingText") {
        let isDataSame=false;
        settings[tabKey].settingsData[0].floatingText.map((item) => {
          const index = defaultFloatingSettings.findIndex(
            (setting) => setting.type === item.type
          );
          const defaultItem = defaultFloatingSettings.find(
            (setting) => setting.type === item.type
          );
          if(item.keyValue!==defaultItem.keyValue && defaultItem.keyValue !== item.prevValue){
             isDataSame=true;
          }
          if (item.isLock === "true") {
            defaultFloatingSettings[index] = {
              ...item,
              isLock: item.isLock,
            };
          } else {
            defaultFloatingSettings[index] = {
              ...defaultItem,
              isLock: item.isLock,
            };
          }
        });
        isDataSame= isLock==='true' ? false : isDataSame;
        settingsData.restoreDefaultSettings.floating = isDataSame;
      }
    }
    let defaultSettings = {};
    const defaultsMap = {
      cipherText: defaultCipherSettings,
      floatingText: defaultFloatingSettings,
    };

    if (defaultsMap[level.current]) {
      defaultSettings = {
        ...settings[tabKey].settingsData[0],
        [level.current]: [...defaultsMap[level.current]],
      };
    }

    console.log(defaultSettings);
    settingsData.Settings = [defaultSettings];
    dispatch(storeSettingsData(settingsData));
  };

  const levelMap = {
    ["DirectSendDefaults"]: {
      [selectedLanguage.LstLanguageCodes.UI_TrackViews]: "l1",
      [selectedLanguage.LstLanguageCodes.UI_TrackReaders]: "l2",
      [selectedLanguage.LstLanguageCodes.UI_LimitReaders]: "l3",
    },
    ["ContentSecurity"]: {
      [selectedLanguage.LstLanguageCodes.UI_CipherTextTab]: "cipherText",
      [selectedLanguage.LstLanguageCodes.UI_FloatingTextTab]: "floatingText",
    },
  };

  level.current = levelMap[tabMenuText]?.[activeTab] || "";

  const levelMap2 = {
    ["DirectSendDefaults"]: {
      [selectedLanguage.LstLanguageCodes.UI_TrackViews]: "L1",
      [selectedLanguage.LstLanguageCodes.UI_TrackReaders]: "L2",
      [selectedLanguage.LstLanguageCodes.UI_LimitReaders]: "L3",
    },
    ["ContentSecurity"]: {
      [selectedLanguage.LstLanguageCodes.UI_CipherTextTab]: "cipherText",
      [selectedLanguage.LstLanguageCodes.UI_FloatingTextTab]: "floatingText",
    },
  };

  const LevelControls =
    controlData?.[levelMap2[tabMenuText]?.[activeTab]] || [];

  //console.log("LevelControls", LevelControls);

  // console.log("controlData", controlData);
  let commonControls = [];
  let isOverride = "false";
  let isLock = "false";
  if (LevelControls.length > 0) {
    commonControls = [...LevelControls];
    if (tabMenuText === "DirectSendDefaults") {
      const isVotingSelected = commonControls.some(
        (s) => s.settingType === "Voting" && s.value === "false"
      );
      if (isVotingSelected) {
        commonControls = commonControls.filter(
          (s) => s.settingType !== "ShareVotes"
        );
      }
    } else if (tabMenuText === "ContentSecurity") {
      const isCipherPattern = commonControls.some(
        (s) => s.settingType === "CipherPattern" && s.value !== "2"
      );
      if (isCipherPattern) {
        commonControls = commonControls.filter(
          (s) => s.settingType !== "Shape"
        );
      }
    }
    isOverride =
      commonControls.filter((setting) => setting.Override === "true").length ===
      commonControls.length
        ? "true"
        : "false";
    isLock =
      commonControls.filter((setting) => setting.Lock === "true").length ===
      commonControls.length
        ? "true"
        : "false";
    
    if (settingFor === "User") {
      disableOnLock = isLock === "true" ? true : false;
    } 
    
  }

  return (
    <div className="tabs-page tabbed">
      <ul className="nav nav-tabs" role="tablist">
      {tabs.map(tab => {
  const isCipherTab = tab.id === "Cipher Text";
  const isFloatingTab = tab.id === "Floating Text";

  const isDisabled =
    (selectedType === "Floating Text Only" && isCipherTab) ||
    (selectedType === "Cipher Text Only" && isFloatingTab);

  return (
    <li
      key={tab.id}
      role="presentation"
      className={`nav-item ${activeTab === tab.id ? "active" : ""}`}
      onClick={() => !isDisabled && onTabSelectionHandler(tab.id)}
      style={{
        pointerEvents: isDisabled ? "none" : "auto",
        opacity: isDisabled ? 0.5 : 1
      }}
    >
      <a
        role="tab"
        className={`nav-link d-flex align-items-center ${
          activeTab === tab.id ? "active" : ""
        }`}
      >
        <span className={tab.className}>{tab.icontext}</span>
        <span className="ms-1">{tab.label}</span>
      </a>
    </li>
  );
})}



        {tabMenuText === "ContentSecurity" && (
          <>
            <li className=" ms-auto no-tabbed">
              <a
                role="button"
                aria-disabled={disableOnLock}
                onClick={restoreContentSecurityDefaults}
                title={selectedLanguage.LstLanguageCodes.UI_RestoreToDefaults}
                className="nav-link d-flex align-items-center"
                style={{ cursor: (disableOnLock) ? "not-allowed" : 'pointer', color: "#2f3542"}}>
                <span class="material-icons rotate-90">
                  {" "}
                  settings_backup_restore{" "}
                </span>
              </a>
            </li>
            <li className="no-tabbed">
              <a
                role="button"
                onClick={handlePreview}
                title={selectedLanguage.LstLanguageCodes.UI_Preview}
                className="nav-link d-flex align-items-center"
                style={{ cursor: "pointer", color: "#2f3542" }}>
                <span className="material-icons font-24">preview</span>
              </a>
            </li>
          </>
        )}
        {tabMenuText === "DirectSendDefaults" && (
          <li className="ms-auto no-tabbed">
            <a
              role="button"
              aria-disabled={disableOnLock}
              onClick={restoreDirectSendDefaults}
              title={selectedLanguage.LstLanguageCodes.UI_RestoreToDefaults}
              className="nav-link d-flex align-items-center"
              style={{
                cursor: disableOnLock ? "not-allowed" : "pointer",
                color: "#2f3542",
              }}>
              <span className="material-icons rotate-90">
                settings_backup_restore
              </span>
            </a>
          </li>
        )}
      </ul>

      <div className="tab-content">
        <div
          className="tab-pane fade show active"
          role="tabpanel"
          key={activeTab}>
          <div className="pt-3 mt-2">
            {settingFor === "Company" && (
              <ControlMenu
                containerClassname={`mb-3 row align-items-center mx-1`}
                settingType={"SelectAll"}
                companyLevel={settingFor === "Company" ? true : false}
                selectAll={true}
                configLevel={LevelControls[0]?.configLevel}
                level={level.current}
                Override={isOverride}
                Lock={isLock}
              />
            )}
            {LevelControls.map((control) => {
              return (
                <>
                  <ControlMenu
                    key={control.id}
                    {...control}
                    companyLevel={settingFor === "Company" ? true : false}
                  />
                </>
              );
            })}
          </div>
        </div>
      </div>
      <PreviewPopup
        imagePreview={imagePreview}
        isOpenModal={ispreviewClick}
        handleCloseFnLnModal={handleCloseFnLnModal}
        floatingTextSettings={
          selectedType !== "Cipher Text Only" ? FloatingTextSettings : null
        }
        PreviewText={selectedLanguage.LstLanguageCodes.UI_Preview}
        selectedType={selectedType}
      />
      {openLoader ? (
        <LoadingSpinner
          className={openLoaderSearch ? "backgroundTransprent" : undefined}
        />
      ) : null}
    </div>
  );
}
